const ApiUrl = {
  // https://grod.staging.gs-robot.com/project/36/interface/api/29301
  personCurrentLocation: "/lbs/v1alpha1/personCurrentLocation:query",
  // https://grod.staging.gs-robot.com/project/335/interface/api/29327
  mapMetaDataAndPicture: "/atlas/v1alpha1/mapMetaDataAndPicture:query",
  queryMapFence:'/atlas/v1alpha1/maps/:queryMapFence'
};

export default ApiUrl;
